module.exports = __webpack_public_path__ + "static/media/user.23fe53fa.png";